import * as firmwareErrorCodes from '../../consts/iot/firmwareErrorCodes';
import ModalTypes from '../../enums/app/modalTypes';
import {selectFirmwareFwuTarget} from '../../state/selectors/iotDevice';
import {selectMwDeviceFirmwareData} from '../../state/selectors/mwDevice';
import {getState} from '../../state/store';
import converter from '../../utils/converter';
import FwuDownloadOrParseError from '../errors/firmware/fwuDownloadOrParseError';
import FwuDownloadUrlIsEmptyError from '../errors/firmware/fwuDownloadUrlIsEmptyError';
import fwuPackageService from '../fwu/fwuPackageService';
import mwMessageRequestService from '../iot/mwMessageRequestService';
import log from '../logger/log';
import modalService from '../modalService';
import appRouterService from '../route/appRouterService';
import server from '../server/server';
import fwuClientService from './fwuClientService';
import fwuTargetService from './fwuTargetService';

let fwuPackage = undefined;

const clearPackageData = () => {
    fwuPackage = null;
};

const downloadFwuPackage = async (fwu_target, onSuccess, onFwuError) => {
    try {
        if (fwuPackage) return true;

        await downloadFirmware(fwu_target, onSuccess);

        return true;
    } catch (e) {
        log.error(`FWUService: FWU package downloading is failed, ${e}`);

        mwMessageRequestService.onFwuErrorHandler({errorCode: e.code, onError: onFwuError, fwu_target});

        return false;
    }
};

const downloadFirmware = async (fwu_target, onSuccess) => {
    const firmwareData = selectMwDeviceFirmwareData(getState());
    const firmwareTarget = fwuTargetService.getIotTargetByFwuTarget(firmwareData, fwu_target);
    const {download_url} = firmwareTarget || {};

    if (!download_url) throw new FwuDownloadUrlIsEmptyError();

    try {
        const res = await server.get(download_url);

        fwuPackage = res.data;

        log.debug(`FWUService: FWU package for ${fwu_target} has been downloaded successfully`);

        mwMessageRequestService.onPackageLoaded(onSuccess, fwu_target);
    } catch (e) {
        throw new FwuDownloadOrParseError(e);
    }
};

const startFwUpdate = async ({onFwuError, onFwuStatusEvent, onFwuFinish, package_index}) => {
    const fwu_target = selectFirmwareFwuTarget(getState());

    if (fwuPackage) {
        log.info(`FWUService: start FWU update process. fwuTarget: ${fwu_target}`);

        const FwuClient = fwuClientService.getFwuClient(fwu_target);
        const options = {
            fwu_target,
            fwuPackageData: fwuPackage,
            onFwuError,
            onFwuFinish,
            onFwuStatusEvent,
        };
        const fwuClient = new FwuClient(options);

        fwuClient.startFwUpdate(package_index);
    } else {
        mwMessageRequestService.onFwuErrorHandler({
            errorCode: firmwareErrorCodes.START_NOT_FOUND_DATA,
            fwu_target,
            onError: onFwuError,
        });

        log.info(`FWUService: startFwUpdate error, package is not loaded. fwuTarget: ${fwu_target}`);
    }
};

const getFwUpdateFinishAfterRebootEvent = () => fwuPackage?.reboot_after_fwu_message;

const convertHexIndexToInt = (hex) => {
    const hexIndexReversed = hex
        .match(/.{1,2}/g)
        .reverse()
        .join('');
    const index = converter.hex2dec(hexIndexReversed);

    return parseInt(index);
};

const initiateUpdateFirmwareMessage = (target) => {
    const fwuInfo = fwuPackageService.getFwuInfoByFwuTargetStatic(target);
    const version = fwuInfo?.availableFirmwares ? fwuInfo?.availableFirmwares[0]?.version : undefined;

    // hide some modals from background (e.g. reset failed)
    modalService.hideModal(ModalTypes.FWU_ERROR);

    appRouterService.forwardToUpdateFWPage({
        target,
        version,
        isSblFirmware: fwuInfo?.isSblFirmware,
    });
};

export default {
    clearPackageData,
    convertHexIndexToInt,
    downloadFirmware,
    downloadFwuPackage,
    getFwUpdateFinishAfterRebootEvent,
    initiateUpdateFirmwareMessage,
    startFwUpdate,
};
